import { useState } from "react";
import { useTranslation } from "react-i18next";
import { reportOAuthError } from "../../firebase/oauthErrors";
import { signInWithApplePopup } from "../../firebase/apple";
import { useAuthWithApple } from "../../hooks/useAuth";

export const AppleLoginButton = ({ compact = false }: { compact?: boolean }) => {
  const appleAuthMutation = useAuthWithApple();
  const { t } = useTranslation();
  // The native sheet takes a while and the mutation only starts afterwards —
  // without this the button stays live and a second tap opens a second sheet.
  const [isSigningIn, setIsSigningIn] = useState(false);
  const busy = isSigningIn || appleAuthMutation.isPending;

  const handleClick = async () => {
    if (busy) return;
    setIsSigningIn(true);
    try {
      const { idToken } = await signInWithApplePopup();
      if (idToken) {
        appleAuthMutation.mutate(idToken);
      }
    } catch (error) {
      reportOAuthError("apple", error);
    } finally {
      setIsSigningIn(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={busy}
      className="w-full h-11 auth-tall:h-12 flex items-center justify-center gap-2.5 rounded-xl bg-black hover:bg-gray-900 active:scale-[.99] disabled:opacity-60 disabled:cursor-default transition cursor-pointer"
    >
      {busy ? (
        <span className="auth-spinner w-4 h-4 rounded-full border-2 border-white/40 border-t-white" />
      ) : (
        /* Apple SVG logo */
        <svg width="17" height="17" viewBox="0 0 814 1000" fill="white" aria-hidden="true">
          <path d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76 0-103.7 40.8-165.9 40.8s-105-57.8-155.5-127.4C46 790.7 0 663 0 541.8c0-207.5 135.4-317.3 269-317.3 70.1 0 128.4 46.4 172.5 46.4 42.8 0 109.6-49 192.5-49 30.8 0 133.3 2.6 198.3 99zM554.3 161.8c31.1-36.9 53.1-88.1 53.1-139.3 0-7.1-.6-14.3-1.9-20.1-50.6 1.9-110.8 33.7-147.1 75.8-28.5 32.4-55.1 83.6-55.1 135.5 0 7.8 1.3 15.6 1.9 18.1 3.2.6 8.4 1.3 13.6 1.3 45.4 0 102.5-30.4 135.5-71.3z" />
        </svg>
      )}
      <span className="text-[15px] font-semibold text-white">{compact ? "Apple" : t("authFlow.continueApple", "Продолжить с Apple")}</span>
    </button>
  );
};
